/* ==========================================================================
   MBM DESCENT — scroll dial, key-art parallax, "light up" reveal, CTA wiring.
   Scoped to the .descent container so it never fights main.js / vault-mock.js.
   ========================================================================== */
(function () {
  var root = document.querySelector(".descent");
  if (!root) return;

  var reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  var fill = root.querySelector("#dialFill");
  var pct = root.querySelector("#dialPct");
  var pars = [].slice.call(root.querySelectorAll("[data-par]"));

  function frame() {
    var h = document.documentElement;
    var max = h.scrollHeight - h.clientHeight;
    var sc = h.scrollTop || document.body.scrollTop || 0;
    var p = max > 0 ? sc / max : 0;
    if (fill) fill.style.height = (p * 100).toFixed(1) + "%";
    if (pct) pct.textContent = String(Math.round(p * 100)).padStart(2, "0");
    if (!reduce) {
      pars.forEach(function (bg) {
        var r = bg.parentElement.getBoundingClientRect();
        var off = (r.top + r.height / 2 - innerHeight / 2) / innerHeight;
        bg.style.transform = "scale(1.07) translateY(" + (off * -30).toFixed(1) + "px)";
      });
    }
  }
  addEventListener("scroll", frame, { passive: true });
  addEventListener("resize", frame);

  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) e.target.classList.add("lit"); });
  }, { threshold: 0.25, rootMargin: "0px 0px -8% 0px" });
  root.querySelectorAll(".ch").forEach(function (el) { io.observe(el); });

  /* descent CTAs that should launch the hero vault journey */
  root.addEventListener("click", function (e) {
    var a = e.target.closest("[data-vault]");
    if (!a) return;
    e.preventDefault();
    var which = a.getAttribute("data-vault") === "shop" ? "shop" : "sell";
    if (window.MBMVault && window.MBMVault.enter) {
      window.scrollTo({ top: 0, behavior: "auto" });
      window.MBMVault.enter(which);
    } else {
      location.href = which === "shop" ? "#collections" : "#sell";
    }
  });

  /* smooth-scroll for in-descent jump links (e.g. We Buy "How It Works" -> the Memphis Standard) */
  root.addEventListener("click", function (e) {
    var a = e.target.closest('a[href^="#d-"]'); if (!a) return;
    var t = document.querySelector(a.getAttribute("href")); if (!t) return;
    e.preventDefault();
    t.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "start" });
  });

  /* left "Shop the Vault" FAB -> the showroom vault (mirrors the right Get-an-Offer FAB) */
  (function () {
    var fab = document.createElement("a");
    fab.className = "d-shopfab";
    fab.href = "#";
    fab.setAttribute("aria-label", "Shop the Vault");
    fab.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M3 4h2l2.3 11.5a1.5 1.5 0 0 0 1.5 1.2h8.4a1.5 1.5 0 0 0 1.5-1.2L21 8H6.3"/><circle cx="10" cy="20" r="1.3"/><circle cx="17.5" cy="20" r="1.3"/></svg>Shop the Vault';
    fab.addEventListener("click", function (e) {
      e.preventDefault();
      if (window.MBMVault && window.MBMVault.enter) { window.scrollTo({ top: 0, behavior: "auto" }); window.MBMVault.enter("shop"); }
    });
    document.body.appendChild(fab);
    var sc = function () { if ((window.scrollY || 0) > 480) fab.classList.add("on"); else fab.classList.remove("on"); };
    addEventListener("scroll", sc, { passive: true }); sc();
  })();

  /* Private Vault: "Enter" plays the door-open clip (gold light), then goes to the inventory page */
  root.addEventListener("click", function (e) {
    var a = e.target.closest("[data-pv]"); if (!a) return;
    e.preventDefault();
    var href = a.getAttribute("href") || "private-vault.html";
    var ov = document.createElement("div"); ov.className = "d-pv-overlay";
    ov.style.backgroundImage = "url('assets/img/private-vault-door.jpg')";  // closed-door still as a poster so it is never black
    var v = document.createElement("video");
    v.src = "assets/img/_proofs/private-vault.mp4"; v.muted = true; v.autoplay = true; v.playsInline = true;
    v.setAttribute("muted", ""); v.setAttribute("autoplay", ""); v.setAttribute("playsinline", ""); v.preload = "auto";
    ov.appendChild(v); document.body.appendChild(ov);
    requestAnimationFrame(function () { ov.classList.add("on"); });
    var done = false, go = function () { if (done) return; done = true; location.href = href; };
    v.addEventListener("ended", go);
    v.addEventListener("timeupdate", function () { if (v.duration && v.currentTime >= v.duration - 0.35) go(); });  // navigate at the gold peak (clip end)
    v.play().catch(function () {});  // if autoplay is blocked, the still shows and the safety timer navigates
    setTimeout(go, 5300);  // safety: ~5s clip
  });

  /* populate the We Buy real-slab showcase (drift loop needs the set twice) */
  (function () {
    var track = document.getElementById("slabTrack"); if (!track) return;
    var slabs = ["victor","ja-morant","drake-sapphire","jayden-kaboom","brock-gold","brady-snakeskin","hurts-camo","caleb-select","jayden-zebra","crews-auto","drake-pandora","stroud-gold","brock-bowers-color","jeanty-auto","nabers-auto","chet-auto","lombard-auto","drake-flawless","brock-sparkle","brady-etopss","dart-prizm","ward-auto","holliday-auto","stroud-spectra","nix-kaboom","jayden-auto","brady-flawless","victor-metro","bo-embers","btj","brock","persall","jayden"];
    var html = "";
    for (var pass = 0; pass < 2; pass++) { for (var i = 0; i < slabs.length; i++) { html += '<figure><img src="' + (window.MBM_ASSET_BASE || 'assets/img/slabs/') + 'slab-' + slabs[i] + '.jpg" alt="" loading="lazy"></figure>'; } }
    track.innerHTML = html;
  })();

  frame();
})();
